// 영어 지역명 → 한글 변환

const REGION_MAP = {
    // 광역시·도
    'Seoul': '서울',
    'Busan': '부산',
    'Incheon': '인천',
    'Daegu': '대구',
    'Daejeon': '대전',
    'Gwangju': '광주',
    'Ulsan': '울산',
    'Sejong': '세종',
    'Gyeonggi-do': '경기',
    'Gyeonggi': '경기',
    'Gangwon-do': '강원',
    'Gangwon': '강원',
    'Chungcheongbuk-do': '충북',
    'Chungcheongnam-do': '충남',
    'Jeollabuk-do': '전북',
    'Jeollanam-do': '전남',
    'Gyeongsangbuk-do': '경북',
    'Gyeongsangnam-do': '경남',
    'Jeju-do': '제주',
    'Jeju': '제주',

    // 주요 도시
    'Seosan City': '서산',
    'Seosan-si': '서산',
    'Seosan': '서산',
    'Jinju': '진주',
    'Jinju-si': '진주',
    'Suwon': '수원',
    'Suwon-si': '수원',
    'Yongin': '용인',
    'Goyang': '고양',
    'Bucheon': '부천',
    'Seongnam': '성남',
    'Anyang': '안양',
    'Ansan': '안산',
    'Pyeongtaek': '평택',
    'Gimpo': '김포',
    'Gimpo-si': '김포',
    'Hwaseong': '화성',
    'Namyangju': '남양주',
    'Cheonan': '천안',
    'Jeonju': '전주',
    'Cheongju': '청주',
    'Pohang': '포항',
    'Changwon': '창원',
    'Gimhae': '김해',
    'Ulsan': '울산',
    'Asan': '아산',
    'Wonju': '원주',
    'Chuncheon': '춘천',
    'Gangneung': '강릉',

    // 서울 구
    'Gangnam-gu': '강남구',
    'Gangnam': '강남구',
    'Seocho-gu': '서초구',
    'Songpa-gu': '송파구',
    'Mapo-gu': '마포구',
    'Yongsan-gu': '용산구',
    'Jongno-gu': '종로구',
    'Jung-gu': '중구',
    'Gangdong-gu': '강동구',
    'Gangbuk-gu': '강북구',
    'Gangseo-gu': '강서구',
    'Gwanak-gu': '관악구',
    'Gwangjin-gu': '광진구',
    'Guro-gu': '구로구',
    'Geumcheon-gu': '금천구',
    'Nowon-gu': '노원구',
    'Dobong-gu': '도봉구',
    'Dongdaemun-gu': '동대문구',
    'Dongjak-gu': '동작구',
    'Seodaemun-gu': '서대문구',
    'Seongbuk-gu': '성북구',
    'Seongdong-gu': '성동구',
    'Yangcheon-gu': '양천구',
    'Yeongdeungpo-gu': '영등포구',
    'Eunpyeong-gu': '은평구',
    'Jungnang-gu': '중랑구',

    // 부산 구
    'Haeundae-gu': '해운대구',
    'Busanjin-gu': '부산진구',
    'Dongnae-gu': '동래구',
    'Saha-gu': '사하구',
    'Buk-gu': '북구',
    'Suyeong-gu': '수영구',
    'Sasang-gu': '사상구',
    'Nam-gu': '남구',
    'Yeonje-gu': '연제구',

    // 인천
    'Bupyeong-gu': '부평구',
    'Yeonsu-gu': '연수구',
    'Namdong-gu': '남동구',
    'Michuhol-gu': '미추홀구',
};

const SUFFIX_REMOVE = ['-do', '-si', '-gun', '-eup', '-myeon', '-ri', ' City', ' Province', ' District'];

export const translateRegion = (text) => {
    if (!text) return text;

    // 정확 매칭 우선
    if (REGION_MAP[text]) return REGION_MAP[text];

    // 부분 매칭 (단어별)
    let result = text;
    Object.entries(REGION_MAP).forEach(([en, ko]) => {
        const re = new RegExp(`\\b${en}\\b`, 'gi');
        result = result.replace(re, ko);
    });

    // 남은 영문 접미사 제거
    SUFFIX_REMOVE.forEach(s => {
        result = result.replace(new RegExp(s, 'gi'), '');
    });

    return result.trim();
};

export default translateRegion;
